import { useUiLanguage } from "@/i18n/useUiLanguage";
import { tr } from "@/i18n/copy";
import { Download } from "lucide-react";

export const GUIDE_EDITIONS = [['it', 'Italiano'], ['en', 'English'], ['es', 'Español'], ['fr', 'Français'], ['de', 'Deutsch']].map(([code, name]) => {
  const filename = code === 'it' ? 'TPS_Guida_Studio.pdf' : `TPS_Guide_${code}.pdf`;
  return { code, name, filename, href: `/guides/${filename}` };
});
export function guideForLanguage(language) {
  const code = language?.toLowerCase().split(/[-_]/)[0];
  return GUIDE_EDITIONS.find(edition => edition.code === code) || GUIDE_EDITIONS[0];
}

// A public static document: no login, API wake-up or form submission required.
export default function TpsGuideLink({ className = "" }) {
  const language = useUiLanguage();
  const { code, name, filename, href } = guideForLanguage(language);
  return <a
    href={href}
    hrefLang={code}
    download={filename}
    className={`flex w-fit max-w-full min-h-11 items-center gap-2 rounded text-sm text-zinc-300 underline decoration-white/25 underline-offset-4 transition-colors hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-red-500 ${className}`}
    data-testid="tps-guide-download"
  >
    <Download className="h-4 w-4 shrink-0 text-[#E10600]" aria-hidden="true" />
    <span>{tr("Scarica la guida TPS")} <span className="text-xs text-zinc-400">(PDF · {name})</span></span>
  </a>;
}
